<template>
  <button :class="['action-menu-tab', { 'action-menu-tab--active': isActive }]" @click="onToggleActive">
    <slot />
    <span class="action-menu-tab__text">
      {{ text }}
    </span>
  </button>
</template>

<script setup lang="ts">

interface Props {
  text: string
  isActive: boolean
}

const props = defineProps<Props>()

const emits = defineEmits<{
  (event: 'toggleActive'): void;
}>()

const onToggleActive = () => {
  emits('toggleActive')
}

</script>

<style lang="scss">
$selected-tab: action-menu-tab;

.#{$selected-tab} {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
  gap: 12px;

  &__text {
    font-family: $font-bold;
    font-size: 12px;
    color: $grey-50;
    line-height: 15px;
    transition: color 150ms $animationCurve;
  }

  &:hover {
    cursor: pointer;
    .#{$selected-tab}__text {
      color: $white;
    }
  }

  &--active {
    .#{$selected-tab}__text {
      color: $purple_light;
    }
    &:hover {
      cursor: pointer;
      .#{$selected-tab}__text {
        color: $purple_light;
      }
    }
  }
}

</style>
